import React, {Fragment} from 'react';
import {Seo, Breadcrumb, ScrollTopBtn} from '../components';
import {
  HeaderOne,
  CtaOne,
  // TestimonialOne,
  FooterOne,
  ServiceOne,
  ProcessOne
} from '../containers';

const Service = () => (
  <Fragment>
    <Seo title="Services" />
    <HeaderOne />
    <Breadcrumb
      pageName="Services"
      bgImage="images/breadcumb/breadcumb-bg.jpeg"
    />
    <ServiceOne className="space-top space-extra-bottom" />
    <CtaOne className="space" />
    <ProcessOne className="space-top space-extra-bottom" />
    {/* <TestimonialOne className="space-top space-extra-bottom" /> */}
    <FooterOne />
    <ScrollTopBtn />
  </Fragment>
);

export default Service;